var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReferandEarnIco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.93691 5.9707C3.87491 7.0607 3.10391 8.4307 2.73291 9.9587",
    stroke: "#3C475F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28979 20.4429C9.88079 20.5709 10.4938 20.6419 11.1238 20.6419C12.0158 20.6419 12.8768 20.5059 13.6868 20.2549",
    stroke: "#3C475F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.73389 14.041C3.10489 15.569 3.87589 16.939 4.93789 18.029",
    stroke: "#3C475F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4049 14.4639C18.9859 15.8759 18.2119 17.1329 17.1929 18.1419",
    stroke: "#3C475F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1929 5.8584C18.2119 6.8674 18.9849 8.1244 19.4049 9.5364",
    stroke: "#3C475F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28979 3.5574C9.88079 3.4294 10.4938 3.3584 11.1238 3.3584C12.0158 3.3584 12.8768 3.4944 13.6868 3.7454",
    stroke: "#3C475F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5336 10.2322C22.5099 11.2085 22.5099 12.7915 21.5336 13.7678C20.5573 14.7441 18.9744 14.7441 17.9981 13.7678C17.0218 12.7915 17.0218 11.2085 17.9981 10.2322C18.9744 9.25592 20.5573 9.25592 21.5336 10.2322Z",
    stroke: "#3C475F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8266 17.5691C9.80291 18.5455 9.80291 20.1284 8.8266 21.1047C7.85029 22.081 6.26738 22.081 5.29107 21.1047C4.31476 20.1284 4.31476 18.5455 5.29107 17.5691C6.26738 16.5928 7.85029 16.5928 8.8266 17.5691Z",
    stroke: "#3C475F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8266 2.89532C9.80291 3.87163 9.80291 5.45454 8.8266 6.43085C7.85029 7.40716 6.26738 7.40716 5.29107 6.43085C4.31476 5.45454 4.31476 3.87163 5.29107 2.89532C6.26738 1.91901 7.85029 1.91901 8.8266 2.89532",
    stroke: "#3C475F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferandEarnIco);
export default __webpack_public_path__ + "static/media/referandEarnIco.c6c3b9c0.svg";
export { ForwardRef as ReactComponent };